import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { IntlService } from '@progress/kendo-angular-intl';
import { PDFExportComponent } from "@progress/kendo-angular-pdf-export";
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'diario-report',
  template: `    
    <div style="position: absolute; left: -90000px; top: -90000px;">
    <!--<div>-->
      <kendo-pdf-export #pdf paperSize="Letter" margin="2cm" [scale]="0.5" landscape="true">    

        <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <div class="footerDate">Fecha: {{ print_date | kendoDate: "d MMM y HH:mm:ss" }}</div>
          <div class="footerPageNum">Página {{ pageNum }} de {{ totalPages }}</div>
        </ng-template>
        
        <div class="header">GRÚAS DELHER</div>
        <div class="header">SUC: {{branchName | uppercase}}</div>        
        <div class="header">REPORTE DIARIO</div>
        <div class="header header-last">FECHA: {{ date }}</div>

        <div class="header p-24">ENTRADAS</div>

        <vehicles-entries-list [range]="range" [type]="'ENTRY'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></vehicles-entries-list>
        
        <div class="header p-24">SALIDAS (A CRÉDITO)</div>

        <vehicles-entries-list [range]="range" [type]="'OUTPUT_CREDIT'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></vehicles-entries-list>

        <div class="header p-24">SERVICIOS (A CRÉDITO)</div>

        <services-list [range]="range" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></services-list>

        <div class="header p-24">SALIDAS (EFECTIVO)</div>

        <vehicles-entries-list [range]="range" [type]="'OUTPUT'" [payment_type]="'1'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></vehicles-entries-list>

        <div class="header p-24">SALIDAS (TRANSFERENCIA Y TARJETA)</div>

        <vehicles-entries-list [range]="range" [type]="'OUTPUT'" [payment_type]="'2,3'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></vehicles-entries-list>

        <div class="header p-24">SERVICIOS (EFECTIVO)</div>

        <services-list [range]="range" [payment_type]="'1'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></services-list>

        <div class="header p-24">SERVICIOS (TRANSFERENCIA Y TARJETA)</div>

        <services-list [range]="range" [payment_type]="'2,3'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></services-list>

        <div class="header p-24">CREDITOS (EFECTIVO)</div>

        <credits-list [range]="range" [payment_type]="'1'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></credits-list>

        <div class="header p-24">CREDITOS (TRANSFERENCIA Y TARJETA)</div>

        <credits-list [range]="range" [payment_type]="'2,3'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></credits-list>

        <!--
        <div class="header header-yellow p-24">SERVICIOS (EN PROCESO)</div>

        <services-list-by-status [range]="range" [service_status]="'1'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></services-list-by-status>

        <div class="header header-orange p-24">SERVICIOS (PAGO PENDIENTE)</div>

        <services-list-by-status [range]="range" [service_status]="'3'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></services-list-by-status>
        -->

        <div class="header p-24">GASTOS (EFECTIVO)</div>

        <expenses-list [range]="range" [payment_type]="'1'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></expenses-list>

        <div class="header p-24">GASTOS (TRANSFERENCIA Y TARJETA)</div>

        <expenses-list [range]="range" [payment_type]="'2,3'" [view_date]="view_dates" (resultChange)="resultChangeEvent($event)"></expenses-list>

        <div class="div-sum p-24">
          <table class="table-sum">
            <tbody>              
              <tr>
                <td colspan="2" class="header-sum">EFECTIVO</td>
              </tr>
              <tr>
                <td width="160">INGRESOS:</td>
                <td width="300"><b>{{intl.formatNumber(sum_inputs_efe, 'c2')}}</b></td>
              </tr>
              <tr>
                <td width="160">EGRESOS:</td>
                <td width="300" class="negative"><b>{{intl.formatNumber(-sum_outputs_efe, 'c2')}}</b></td>
              </tr>
              <tr>
                <td width="160">SUBTOTAL:</td>
                <td width="300" class="subtotal-sum {{((sum_inputs_efe - sum_outputs_efe) < 0) ? 'negative': ''}}"><b>{{intl.formatNumber(sum_inputs_efe - sum_outputs_efe, 'c2')}}</b></td>
              </tr>
              <tr>
                <td colspan="2" class="header-sum">TRANSFERENCIA Y TARJETA</td>
              </tr>
              <tr>
                <td width="160">INGRESOS:</td>
                <td width="300"><b>{{intl.formatNumber(sum_inputs_oth, 'c2')}}</b></td>
              </tr>
              <tr>
                <td width="160">EGRESOS:</td>
                <td width="300" class="negative"><b>{{intl.formatNumber(-sum_outputs_oth, 'c2')}}</b></td>
              </tr>
              <tr>
                <td width="160">SUBTOTAL:</td>
                <td width="300" class="subtotal-sum {{((sum_inputs_oth - sum_outputs_oth) < 0) ? 'negative': ''}}"><b>{{intl.formatNumber(sum_inputs_oth - sum_outputs_oth, 'c2')}}</b></td>
              </tr>
              <tr>
                <td colspan="2" class="header-sum">&nbsp;</td>
              </tr>
              <tr>
                <td width="160">TOTAL:</td>
                <td width="300" class="total-sum"><b>{{intl.formatNumber(sum_inputs_efe - sum_outputs_efe + sum_inputs_oth - sum_outputs_oth, 'c2')}}</b></td>
              </tr>
            <tbody>            
          </table>
        </div>

      </kendo-pdf-export>
    <div>`,
  styleUrls: ["./styles/pdf-styles.css", "./styles/report-styles.css"],
  styles: [`
    .footerPageNum {
      position: absolute;
      right: 120px;
      bottom: 100px;
    }
    .footerDate {
      position: absolute;
      left: 120px;
      bottom: 100px;
    }
    .div-sum {
      font-size: 16px; 
      height: 330px;
    }
    .table-sum {
      float: right; 
      text-align: right;
    }
    .header-sum {
      background-color: #fafafa;
    }
    .subtotal-sum {
      font-size: 24px;
    }
    .total-sum {
      font-size: 32px;
    }
  `]
})
export class DiarioReportComponent implements OnInit {

  //ExcelExport
  @ViewChild('pdf', {static: false}) pdf !: PDFExportComponent;
  

  public name: string = 'report';
  public date: String = '';

  protected branchName: string = environment.branchName;

  protected scale: number = 0.5;

  protected range = { start: null, end: null };
  protected view_dates: boolean = false;

  protected sum_inputs_efe: number = 0;
  protected sum_inputs_oth: number = 0;
  protected sum_outputs_efe: number = 0;
  protected sum_outputs_oth: number = 0;
  protected print_date = null;

  protected resolvesFn: { (value: number): void; }[] = [];

  protected promises: Promise<number>[] = [];


  constructor(protected service : DatasourceService, protected intl: IntlService) { 

  }

  public downloadByRange(range: any, view_dates: boolean = true) {

    let that = this;

    this.print_date = new Date();

    this.sum_inputs_efe = 0;
    this.sum_inputs_oth = 0;
    this.sum_outputs_efe = 0;
    this.sum_outputs_oth = 0;
    
    this.range = range;
    this.view_dates = view_dates;    
    
    this.resolvesFn = [];
    this.promises = [0, 1, 2, 3, 4, 5, 6, 7, 8].map(function (i, index, array) {
      // console.log("Promise " + i + " initialized");
      return new Promise((resolve, reject) => {
        that.resolvesFn.push(resolve);
      })
    });

    // console.log(this.promises);

    Promise.all(this.promises).then((values) => {
      console.log('All promises finished.', values);
      setTimeout(function(){
        that.pdf.saveAs(`${that.name}.pdf`)
      }, 1000);      
    });    

  }

  protected resultChangeEvent(event: any): void {

    console.log(event.name, event.result, event.sum);
    let that = this;

    switch(event.name){
      case 'VEHICLES_ENTRY_': {

        if(that.promises.length){
          that.resolvesFn[0](event.sum);
        }
        
      }; break;
      case 'VEHICLES_OUTPUT_1': { 
        
        this.sum_inputs_efe += event.sum; 
        if(that.promises.length){
          that.resolvesFn[1](event.sum);
        }

      }; break;
      case 'VEHICLES_OUTPUT_2,3': { 

        this.sum_inputs_oth += event.sum; 
        if(that.promises.length){
          that.resolvesFn[2](event.sum);
        }

      }; break;
      case 'SERVICES_1': { 

        this.sum_inputs_efe += event.sum; 
        if(that.promises.length){
          that.resolvesFn[3](event.sum);
        }

      }; break;
      case 'SERVICES_2,3': { 

        this.sum_inputs_oth += event.sum; 
        if(that.promises.length){
          that.resolvesFn[4](event.sum);
        }

      }; break;      
      case 'EXPENSES_1': {

        this.sum_outputs_efe += event.sum;
        if(that.promises.length){
          that.resolvesFn[5](event.sum);
        } 

      }; break;
      case 'EXPENSES_2,3': {

        this.sum_outputs_oth += event.sum;
        if(that.promises.length){
          that.resolvesFn[6](event.sum);
        }

      }; break;
      case 'CREDITS_1': { 

        this.sum_inputs_efe += event.sum; 
        if(that.promises.length){
          that.resolvesFn[7](event.sum);
        }

      }; break;
      case 'CREDITS_2,3': { 

        this.sum_inputs_oth += event.sum; 
        if(that.promises.length){
          that.resolvesFn[8](event.sum);
        }

      }; break;
    }
    
  }

  public formatDate(date: string) : string {
    const tzDate = ZonedDate.fromUTCDate(new Date(date), environment.timezone);
    let d: Date = new Date(tzDate.toUTCString().replace('Dev', 'Dec'))
    return this.intl.formatDate(d, "d MMM y");
  }

  ngOnInit() {

  }

}
